import styles from "./radioInput.module.scss";

export const RadioInputContainer = (props: any) => {
  const { className, children } = props;
  return (
    <div className={`${styles.radio_input_container} ${className}`}>
      {children}
    </div>
  );
};
